import { defineComponent } from "vue";
import ChatItem, { AbstractChatItem } from "../ChatItem";
import UnremoveClientChatPacket from "../../packets/client/UnremoveClientChatPacket.1";
import RemoveClientChatPacket from "../../packets/client/RemoveClientChatPacket";

export interface ChatItemPoll extends AbstractChatItem {
}

export default defineComponent({
    components: {
        ChatItem,
    },

    template: `
        <ChatItem
            v-if="item.poll"
            :class="{ 'ChatPoll': true, 'ChatItem--poll': true, 'ChatItem--removed': item.removed, 'ChatPoll--opened': item.poll.opened, 'ChatPoll--closed': !item.poll.opened, 'ChatItem--voted': item.poll.answer, 'ChatItem--notvoted': !item.poll.answer }"
            :kind="item.kind"
            :date="item.date"
            :controls="admin"
            :actions="actions"

            @action="onAction"
        >
            <div v-if="admin" class="ChatPoll__admin">
                <div>Głosowanie: <b>{{ item.poll.opened ? 'otwarte' : 'zamknięte' }}</b></div>
                <div>Ukryte: <b>{{ item.poll.hidden ? 'tak' : 'nie' }}</b></div>
                <div>Oddano głosów: <b>{{ item.poll.votes }}</b></div>

                <div class="ChatPoll__admin-feed"><a :href="item.poll.feed" target="_blank">CSV</a></div>
            </div>

            <div class="ChatPoll__question" v-html="item.poll.question"></div>

            <div v-if="!item.poll.answer" class="ChatPoll__answers">
                <ul>
                    <li v-for="answer in item.poll.answers" :class="{ 'ChatPoll__answer': true, 'ChatPoll__answer--selected': item.poll.answer == answer.id }">
                        <button
                            type="button"
                            :disabled="!item.poll.opened || admin || !user"

                            @click="onClickVote(answer)"
                        >
                            {{ answer.text }}
                        </button>

                        <div v-if="admin" class="ChatPoll__answer-results">
                            <span class="ChatPoll__answer-results-getPercent">{{ getPercent(answer) }}</span>
                            <span class="ChatPoll__answer-results-votes">{{ answer.votes }}</span>
                        </div>
                    </li>
                </ul>
            </div>

            <div v-if="item.poll.answer" class="ChatPoll__result">
                <div class="ChatPoll__result-selected">Wybrano: <b>{{ item.poll.answer.text }}</b></div>
                <div>Dziękujemy za oddanie głosu!</div>
            </div>

            <div v-else-if="!item.poll.opened" class="ChatPoll__message">
                Głosowanie zamknięte.
            </div>
        </ChatItem>
    `,

    props: {
        item: { type: Object, required: true },
        user: { type: Object },
        admin: { type: Boolean },
    },

    computed: {
        actions() {
            const result = [];

            result.push({
                id: 'movebottom',
                name: 'Na koniec',
            });

            result.push({
                id: 'open',
                name: this.item.poll.opened ? 'Zamknij' : 'Otwórz',
            });

            result.push({
                id: 'hide',
                name: this.item.poll.hidden ? 'Pokaż' : 'Ukryj',
            });

            result.push({
                id: 'remove',
                name: this.item.removed ? 'Przywróć' : 'Usuń',
            });

            return result;
        },
    },

    methods: {
        getPercent(answer: any) {
            let result = 0;

            if (this.item.poll.votes) {
                result = Math.round(answer.votes / this.item.poll.votes * 100);
            }

            return result + '%';
        },

        onClickVote(answer: any) {
            this.$root.socket.emit('poll.vote', {
                id: this.item.id,
                vote: answer.id,
            });
        },

        async onAction(action: string) {
            this.visible_actions = false;

            switch (action) {
                case 'movebottom':
                    this.$root.socket.emit('poll.movebottom', {
                        id: this.item.id,
                    });
                    break;

                case 'open':
                    this.$root.socket.emit('poll.open', {
                        id: this.item.id,
                        value: !this.item.poll.opened,
                    });
                    break;

                case 'hide':
                    this.$root.socket.emit('poll.hide', {
                        id: this.item.id,
                        value: !this.item.poll.hidden,
                    });
                    break;

                case 'remove':
                    if (this.admin && this.item.removed) {
                        this.$root.sendPacket(new UnremoveClientChatPacket(this.item.id));
                    } else {
                        this.$root.sendPacket(new RemoveClientChatPacket(this.item.id));
                    }
                    break;
            }

            this.$emit('action', { action: action, item: this.item });
        },
    }
});
